require('../../scss/pages/subpages/akcni-letenky.scss');
import { offersWidget } from '../offers/main'

(function ($) {
  $.fn.extend({
    offersWidget
  })
})(jQuery)

$(document).ready(() => {
  // hover na offery
  (function offers(selector) {
    let hiddenParts = $(selector).find('.hidden-part')

    hiddenParts.each((index, item) => {
      let self = $(item)
      self.parent('.content').css({
        "bottom": `-${self.outerHeight()}px`
      })
    })
  })('#airticket-news')
})



// WEBPACK FOOTER //
// ./src/js/subpages/akcni-letenky.js